import i18n from './../../shared/i18n';
import BaseModel from "../../core/components/input-widget/BaseModel";

export default class ConditionReportRequestSearchModel extends BaseModel {
  email = null;
  first_name = null;
  last_name = null;
  status = null;
  rejected_by = null;
  sent_by = null;
  inventory_uuid = null;
  sale_no = null;
  lot_no = null;
  sale_title = null;
  department = null;
  category = null;

  rules = {};

  attributeLabels = {
    email: i18n.t('Email'),
    first_name: i18n.t('First Name'),
    last_name: i18n.t('Last Name'),
    status: i18n.t('Status'),
    rejected_by: i18n.t('Rejected By'),
    sent_by: i18n.t('Sent By'),
    inventory_uuid: i18n.t('Inventory'),
    sale_no: i18n.t('Sale No'),
    sale_title: i18n.t('Sale Title'),
    lot_no: i18n.t('Lot No'),
    department: i18n.t('Department'),
    category: i18n.t('Category')
  };

  attributePlaceholders = this.attributeLabels;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  toJSON() {
    const data = super.toJSON();

    delete data.sent_by
    delete data.rejected_by

    return data
  }
}
